import React from 'react';
import CommonComponent from '../CommonComponent';
import { appMethod as app } from '@utils/app';
import { pageInstance } from '@utils/page';

import './GoodsShoppingCart.less';


export class GoodsShoppingCart extends CommonComponent {
  constructor(props) {
    super(props);
    this.options = this.props.options;

    this.state = {
      isVisibled: false,
      showBuyNow: false,
      showVirtualPrice: false,
      goodsInfo: {},
      selectGoodsModelInfo: {
        buyCount: 0
      },
      isShowBottom: false,
      storeStyle: {}
    };
  }

  goodsId = '';
  franchiseeId = '';

  // 展示弹窗。小程序里面通过data里面的数据控制展示，这里是调用这个方法。参数和小程序一致
  show = (options) => {
    let {
      afterSelectedGoods
    } = options;

    this.afterSelectedGoods = afterSelectedGoods;
  }

  showDialog = (data) => {
    this.goodsId = data.goodsId;
    this.franchiseeId = data.franchisee || ''
    let pageInstance = app.getAppCurrentPage();
    this.setData({
      isShowBottom: pageInstance.data.isShowBottom || "",
      showBuyNow: data.showBuynow || '',
      showVirtualPrice: data.showVirtualPrice || ''
    })
    this.getGoodsDetail();
    this.getAppECStoreConfig();
  }

  getGoodsDetail = () => {
    let _this = this;
    app.sendRequest({
      url: '/index.php?r=AppShop/getGoods',
      data: {
        data_id: _this.goodsId,
        sub_shop_app_id: this.franchiseeId
      },
      method: 'post',
      success: function (res) {
        let goods = res.data[0].form_data;
        let defaultSelect = goods.model_items[0];
        let goodsModel = [];
        let selectModels = [];
        let goodprice = 0;
        let goodstock = 0;
        let goodid;
        let selectText = '';
        let goodimgurl = '';
        let virtual_price = '';
        let is_vip_goods = goods.is_vip_goods; 
        let vipprice = 0; 
        if (goods.model_items.length) {
          goodprice = defaultSelect.price;
          goodstock = defaultSelect.stock;
          vipprice = defaultSelect.vip_price || defaultSelect.price;
          goodid = defaultSelect.id;
          goodimgurl = defaultSelect.img_url;
          virtual_price = defaultSelect.virtual_price;
        } else {
          goodprice = goods.price; 
          vipprice = goods.vip_goods_price || goods.price;
          goodstock = goods.stock;
          goodimgurl = goods.cover;
          virtual_price = goods.virtual_price;
        }
        for (let key in goods.model) {
          if (key) {
            let model = goods.model[key];
            goodsModel.push(model);
            selectModels.push(model.subModelId[0]);
            selectText += '“' + model.subModelName[0] + '” ';
          }
        }
        goods.model = goodsModel;

        _this.setData({
          isVisibled: true,
          goodsInfo: goods,
          'selectGoodsModelInfo.price': goodprice,
          'selectGoodsModelInfo.is_vip_goods': is_vip_goods,
          'selectGoodsModelInfo.vipprice': vipprice,
          'selectGoodsModelInfo.stock': goodstock,
          'selectGoodsModelInfo.buyCount': 1,
          'selectGoodsModelInfo.buyTostoreCount': 0,
          'selectGoodsModelInfo.cart_id': '',
          'selectGoodsModelInfo.models': selectModels,
          'selectGoodsModelInfo.modelId': goodid || '',
          'selectGoodsModelInfo.models_text': selectText,
          'selectGoodsModelInfo.imgurl': goodimgurl,
          'selectGoodsModelInfo.virtual_price': virtual_price,
          'selectGoodsModelInfo.max_can_use_integral': goods.max_can_use_integral
        });
      }
    });
  }

  selectGoodsSubModel = (event) => {
    let dataset = event.target.dataset;
    let modelIndex = dataset.modelIndex;
    let submodelIndex = dataset.submodelIndex;
    let data = {};
    let selectModels = this.data.selectGoodsModelInfo.models;
    let model = this.data.goodsInfo.model;
    let text = '';

    selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];

    //拼已选规格文字
    for (let i = 0; i < selectModels.length; i++) {
      let selectSubModelId = model[i].subModelId;
      for (let j = 0; j < selectSubModelId.length; j++) {
        if (selectModels[i] == selectSubModelId[j]) {
          text += '“' + model[i].subModelName[j] + '” ';
        }
      }
    }
    data['selectGoodsModelInfo.models'] = selectModels;
    data['selectGoodsModelInfo.models_text'] = text;

    this.setData(data);
    this.resetSelectCountPrice();
  }

  resetSelectCountPrice = () => {
    let selectModelIds = this.data.selectGoodsModelInfo.models.join(',');
    let modelItems = this.data.goodsInfo.model_items;
    let data = {};
    let cover = this.data.goodsInfo.cover;

    data['selectGoodsModelInfo.buyCount'] = 1;
    data['selectGoodsModelInfo.buyTostoreCount'] = 0;
    for (let i = modelItems.length - 1; i >= 0; i--) {
      if (modelItems[i].model == selectModelIds) {
        data['selectGoodsModelInfo.stock'] = modelItems[i].stock;
        data['selectGoodsModelInfo.price'] = modelItems[i].price;
        data['selectGoodsModelInfo.modelId'] = modelItems[i].id || '';
        data['selectGoodsModelInfo.imgurl'] = modelItems[i].img_url || cover;
        data['selectGoodsModelInfo.virtual_price'] = modelItems[i].virtual_price;
        data['selectGoodsModelInfo.vipprice'] = modelItems[i].vip_price
        break;
      }
    }
    this.setData(data);
  }

  inputBuyCount = (e) => {
    this.setData({
      'selectGoodsModelInfo.buyCount': e.target.value
    })
  }

  clickGoodsMinusButton = () => {
    let count = this.data.selectGoodsModelInfo.buyCount;
    if (count <= 1) {
      return;
    }
    this.setData({
      'selectGoodsModelInfo.buyCount': count - 1
    });
  }
  
  clickGoodsPlusButton= () => {
    let selectGoodsModelInfo = this.data.selectGoodsModelInfo;
    let count = selectGoodsModelInfo.buyCount;
    let stock = selectGoodsModelInfo.stock;

    if (count >= stock) {
      return;
    }
    this.setData({
      'selectGoodsModelInfo.buyCount': count + 1
    });
  }

  sureAddToShoppingCart= () => {
    let _this = this;
    let param = {
      goods_id: _this.data.goodsInfo.id,
      model_id: _this.data.selectGoodsModelInfo.modelId || '',
      num: _this.data.selectGoodsModelInfo.buyCount,
      sub_shop_app_id: this.franchiseeId,
      message_notice_type: 1
    };

    app.sendRequest({
      url: '/index.php?r=AppShop/addCart',
      data: param,
      success: function (res) {
        // 有的组件会有用到这个方法
        if (_this.afterSelectedGoods) {
          _this.afterSelectedGoods();
        }
        _this.hideDialog();
      }
    })
  }

  hideDialog= () => {
    this.setData({
      isVisibled: false,
    });
  }

  getAppECStoreConfig = () => {
    app.getAppECStoreConfig((res) => {
      this.setData({
        storeStyle: res.color_config
      })
    }, this.franchiseeId);
  }

  goPreviewGoodsOrder = () => {
    let _this = this;
    let param = {
      goods_id: _this.data.goodsInfo.id,
      model_id: _this.data.selectGoodsModelInfo.modelId || '',
      num: _this.data.selectGoodsModelInfo.buyCount,
      sub_shop_app_id: this.franchiseeId,
      message_notice_type: 1

    };
    
    app.sendRequest({
      url: '/index.php?r=AppShop/addCart',
      data: param,
      success: function (res) {
        let cart_arr = [res.data],
          pagePath = '/eCommerce/pages/previewGoodsOrder/previewGoodsOrder?cart_arr=' + encodeURIComponent(cart_arr);
          _this.hideDialog();
          app.turnToPage(pagePath);
      }
    })
  }
  

  render() {
    const {
      isVisibled,
      showBuyNow,
      showVirtualPrice,
      goodsInfo,
      selectGoodsModelInfo,
      isShowBottom,
      storeStyle
    } = this.state;
    // 判断当前页是否有导航
    let hasTabNav = app.isTabBarPage();
    return (
      <div className="common-component goods-shopping-cart goodsPayDialog" style={{
        bottom: hasTabNav ? '48px' : ''
      }} hidden={!isVisibled}>
        <div className="goods-detail-contain" style={isShowBottom ? { bottom: '48px'} : {}}>
          <div className="ico-moon icon-closes" onClick={this.hideDialog.bind(this)}></div>
          <div className="goods-detail-header">
            <img className="goods-cover" src={ selectGoodsModelInfo.imgurl || goodsInfo.cover } />
            <div className="select-goods-info">
              <div className="goods-price">
                {selectGoodsModelInfo.is_vip_goods != 1 ? (
                  <React.Fragment>
                    <span style={{color: storeStyle.theme }}>¥{ selectGoodsModelInfo.price }</span>
                    {showVirtualPrice && selectGoodsModelInfo.virtual_price != 0 && <span className="virtualPrice">¥{selectGoodsModelInfo.virtual_price}</span>}
                  </React.Fragment>
                ): (
                  <div className="pay-current-price member-status">
                    <div className="member-price memeber-item" style={{display: 'inline-block'}}>
                      <span>¥</span>
                      <span>{selectGoodsModelInfo.vipprice}</span>
                    </div>
                    {selectGoodsModelInfo.vipPrice != selectGoodsModelInfo.price && <div className="member-logo memeber-item">会员价</div>}
                    <div className="memebr-origin-price memeber-item" style={{color:'#999',display:'inline-block'}}>
                      {showVirtualPrice && selectModelInfo.virtualPrice != 0 && <span className="virtualPrice" style={{marginLeft: 0}}>￥{selectGoodsModelInfo.virtual_price}</span>}
                    </div>
                  </div>
                )}
              </div>
              <div className="goods-stock">库存{ selectGoodsModelInfo.stock }</div>
              {selectGoodsModelInfo.models_text &&<div className="select-model">已选：{ selectGoodsModelInfo.models_text }</div>}
            </div>
          </div>
          <div className="goods-detail-content">
            <div className="goods-dialog-content" hidden={!(goodsInfo.model_items && goodsInfo.model_items.length)}>
              {goodsInfo.model && goodsInfo.model.map((model, modelIndex) => (
                <div className="goods-model" key={modelIndex}>
                <div className="model-title">{model.name}</div>
                <div className="sub-model">
                {
                  model.subModelName.map((name, index) => (
                    <span className={`subModel ${ selectGoodsModelInfo.models[modelIndex] == model.subModelId[index] ? 'select' : '' }`} key={index} data-model-index={modelIndex} data-submodel-index={index} data-submodel-id={model.subModelId[index]} onClick={this.selectGoodsSubModel.bind(this)} style={selectGoodsModelInfo.models[modelIndex] == model.subModelId[index] ? {background: storeStyle.theme + '33', color: storeStyle.theme, borderColor: storeStyle.theme} : {}}>{ name }</span>
                  ))
                }
                </div>
              </div>
              ))}
            </div>
          </div>
          <div className="goods-num-contain">
            <span className="goods-num-title">购买数量：</span>
            <div className="good-number-box pull-right">
              <div className="goods-minus" onClick={this.clickGoodsMinusButton}>-</div>
              <input className="goods-count" type="number" value={ selectGoodsModelInfo.buyCount } onInput={this.inputBuyCount} onChange={this.inputBuyCount} />
              <div className="goods-plus" onClick={this.clickGoodsPlusButton}>+</div>
            </div>
          </div>
          <div className="goods-shopping-bottom">
            <div className="add-shoppingcart" style={{background: storeStyle.secondary, color:  (storeStyle.secondary == '#ACD3FA' || storeStyle.secondary == '#FFCFDF' || storeStyle.secondary == '#ffffff' || storeStyle.secondary == '#DFF3ED' || storeStyle.secondary == '#FAF7ED' ? storeStyle.theme : '')}} onClick={this.sureAddToShoppingCart.bind(this)}>加入购物车</div>
            {showBuyNow && <div className="now-buy" style={{background: storeStyle.theme}} onClick={this.goPreviewGoodsOrder}>立即购买</div>}
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/common/goods-shopping-cart/GoodsShoppingCart.jsx